const _mem = new Map()

export function memSet(key, data, ttlMs = 0) {
  _mem.set(key, {
    data,
    expiresAt: ttlMs > 0 ? Date.now() + ttlMs : 0,
  })
}

export function memGet(key) {
  const entry = _mem.get(key)
  if (!entry) return null
  if (entry.expiresAt > 0 && Date.now() > entry.expiresAt) {
    _mem.delete(key)
    return null
  }
  return entry.data
}

export function memDelete(key) { _mem.delete(key) }
export function memClear()     { _mem.clear() }

const LS_PREFIX  = 'aerj:'
const LS_VERSION = 1

function _lsKey(key) { return `${LS_PREFIX}${key}` }

export function lsSet(key, data, ttlMs = 0) {
  try {
    const payload = JSON.stringify({
      __v: LS_VERSION,
      data,
      expiresAt: ttlMs > 0 ? Date.now() + ttlMs : 0,
    })
    localStorage.setItem(_lsKey(key), payload)
  } catch (error) {
    console.warn('Falha ao tentar armazenar em localStorage: ', error)
    lsPurgeExpired()
    try {
      localStorage.setItem(_lsKey(key), JSON.stringify({ __v: LS_VERSION, data, expiresAt: 0 }))
    } catch (error){
      console.warn('Falha persistente ao tentar armazenar em localStorage: ', error) 
    }
  }
}

export function lsGet(key) {
  try {
    const raw = localStorage.getItem(_lsKey(key))
    if (!raw) return null

    const entry = JSON.parse(raw)

    if (entry.__v !== LS_VERSION) { localStorage.removeItem(_lsKey(key)); return null }

    if (entry.expiresAt > 0 && Date.now() > entry.expiresAt) {
      localStorage.removeItem(_lsKey(key))
      return null
    }

    return entry.data
  } catch (error) {
    localStorage.removeItem(_lsKey(key))
    console.warn('Falha ao tentar recuperar de localStorage, entrada removida:', error)
    return null
  }
}

export function lsDelete(key) { localStorage.removeItem(_lsKey(key)) }

export function lsClear() {
  const toRemove = []
  for (let i = 0; i < localStorage.length; i++) {
    const k = localStorage.key(i)
    if (k?.startsWith(LS_PREFIX)) toRemove.push(k)
  }
  toRemove.forEach(k => localStorage.removeItem(k))
}

export function lsPurgeExpired() {
  const now = Date.now()
  const toRemove = []
  for (let i = 0; i < localStorage.length; i++) {
    const k = localStorage.key(i)
    if (!k?.startsWith(LS_PREFIX)) continue
    try {
      const entry = JSON.parse(localStorage.getItem(k))
      if (entry?.expiresAt > 0 && now > entry.expiresAt) toRemove.push(k)
    } catch (error) {
      console.warn('Falha ao tentar analisar entrada em localStorage, entrada removida:', error)
      toRemove.push(k)
    }
  }
  toRemove.forEach(k => localStorage.removeItem(k))
  return toRemove.length
}

const DEFAULTS = {
  memTTL: 5  * 60_000,
  lsTTL:  10 * 60_000,
}

export async function cacheOr(key, fetchFn, options = {}) {
  const { memTTL, lsTTL, forceRefresh = false } = { ...DEFAULTS, ...options }

  if (!forceRefresh) {
    const fromMem = memGet(key)
    if (fromMem !== null) return fromMem

    const fromLs = lsGet(key)
    if (fromLs !== null) {
      memSet(key, fromLs, memTTL)
      return fromLs
    }
  }

  const data = await fetchFn()

  memSet(key, data, memTTL)
  if (lsTTL > 0) lsSet(key, data, lsTTL)
  return data
}

export function cacheInvalidate(key) {
  memDelete(key)
  lsDelete(key)
}

export function invalidatePrefix(prefix) {
  for (const k of _mem.keys()) {
    if (k.startsWith(prefix)) _mem.delete(k)
  }
  const fullPrefix = _lsKey(prefix)
  const toRemove = []
  for (let i = 0; i < localStorage.length; i++) {
    const k = localStorage.key(i)
    if (k?.startsWith(fullPrefix)) toRemove.push(k)
  }
  toRemove.forEach(k => localStorage.removeItem(k))
}

export const ss = {
  set(key, value) {
    try { sessionStorage.setItem(key, JSON.stringify(value)) } catch (error) {
      console.warn('Falha ao tentar armazenar dados em sessionStorage, entrada não salva: ', error) 
    }
  },
  get(key) {
    try {
      const raw = sessionStorage.getItem(key)
      return raw !== null ? JSON.parse(raw) : null
    } catch (error) {
      console.warn('Falha ao tentar recuperar de sessionStorage:', error)
      return null
    }
  },
  delete(key) { sessionStorage.removeItem(key) },
  clear()     { sessionStorage.clear() },
}

let _purgeTimer = null

export function startPeriodicPurge(intervalMs = 30 * 60_000) {
  if (_purgeTimer) return
  _purgeTimer = setInterval(() => {
    const removed = lsPurgeExpired()
    if (removed > 0) console.debug(`[cacheService] Purge periódico: ${removed} entradas removidas`)
  }, intervalMs)
}

export function stopPeriodicPurge() {
  clearInterval(_purgeTimer)
  _purgeTimer = null
}
